export default "__VITE_ASSET__B2Ef18wK__"